import React from 'react';
import { Modal } from 'antd';
import cx from 'classnames';
import Button from '../Button';
import './Modal.scss';

const FooterButton = (okText, cancelText, onOk, onClose) => (
  <div>
    <Button color="primary" onClick={onOk} text={okText} />
    <Button onClick={onClose} text={cancelText} />
  </div>
);

const CustomModal = (props) => {
  const {
    title,
    children,
    isOpen,
    isFooter,
    onOk,
    onClose,
    width,
    height,
    okText = '확인',
    cancelText = '닫기',
    padding = '15px',
    maskClosable = true,
    overflow = 'auto',
    isBasic = false,
    wrapClassName,
    destroyOnClose,
    // 기본 확인/닫기 2버튼으로 표현 안 되는 footer(예: 좌측 삭제 버튼)를 위한 오버라이드.
    // 넘기지 않으면 기존 isFooter 동작 그대로다.
    footer,
  } = props;
  return (
    <Modal
      wrapClassName={cx('amondz-modal-wrap', wrapClassName)}
      className={cx('amondz-modal', { basic: isBasic })}
      title={title}
      open={isOpen}
      closable={!isBasic}
      styles={{ body: { height: height, padding: padding, overflow: overflow } }}
      maskClosable={maskClosable}
      footer={
        footer !== undefined
          ? footer
          : isFooter
          ? FooterButton(okText, cancelText, onOk, onClose)
          : null
      }
      onCancel={onClose}
      destroyOnClose={destroyOnClose}
      width={width}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
